import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppMenuItem } from '../models/app-menu-item';

@Component({
  selector: 'app-app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.css']
})
export class AppMenuComponent implements OnInit {

  apps:AppMenuItem[] = []
  constructor(
    public dialogRef: MatDialogRef<AppMenuComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppMenuItem
  ) { }

  ngOnInit() {
  }

  onSelectApp(app:AppMenuItem){
    this.dialogRef.close(app);
  }
}
